import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, Inject } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { IconComponent } from '../../ui/icon/icon.component';
import { NetworkService } from 'src/app/core/services/network/network.service';

@Component({
  selector: 'bizz-pwa-reauthentication-required-modal',
  standalone: true,
  imports: [ModalComponent, TranslatePipe, IconComponent],
  templateUrl: './pwa-reauthentication-required-modal.component.html',
  styleUrl: './pwa-reauthentication-required-modal.component.scss'
})
export class PwaReauthenticationRequiredModalComponent {
  public networkService = inject(NetworkService);
  public constructor(public dialogRef: DialogRef, @Inject(DIALOG_DATA) public data: any) { 
  
  }
}
